module.exports = __webpack_public_path__ + "static/img/3032_phase_function_Paper_PointsHejduk_Prediction.e2a7a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3032_phase_function_Paper_PointsHejduk_Prediction.png
// module id = c8p5
// module chunks = 0